// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__ScKtW","label":"LabeledBox_label__35ZuK"};